import Pusher from "pusher-js";
export const pusher = new Pusher("c8b849ca67e195919255", {
  cluster: "ap2",
});
export const prodPusher = new Pusher("03ef0315faada95dd666", {
  cluster: "us2",
});
